import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = process.env.REACT_APP_LOGO_URL;

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Publications", href: "#publications" },
  { label: "Events", href: "#events" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B1211]/90 backdrop-blur-xl border-b border-[#1A2F2A]/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#top" data-testid="nav-logo" className="flex items-center">
          <img
            src={LOGO_URL}
            alt="Cybersyn"
            className="h-10 md:h-14 w-auto"
          />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className="nav-link text-sm font-mono uppercase tracking-widest"
            >
              {link.label}
            </a>
          ))}
          <a
            href="mailto:javier@cybersyn.systems?subject=Consultation%20Request"
            data-testid="nav-cta"
            className="bg-[#34D399] text-[#064E3B] font-medium text-sm px-6 py-2 rounded-full cta-glow hover:bg-[#10B981] transition-colors"
          >
            Get in Touch
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#94A3B8] hover:text-[#34D399] transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#0B1211]/95 backdrop-blur-xl border-t border-[#1A2F2A] px-6 py-6 animate-fade-in"
        >
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              data-testid={`mobile-nav-${link.label.toLowerCase()}`}
              className="block py-3 text-[#94A3B8] hover:text-[#34D399] font-mono text-sm uppercase tracking-widest transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="mailto:javier@cybersyn.systems?subject=Consultation%20Request"
            className="inline-block mt-4 bg-[#34D399] text-[#064E3B] font-medium text-sm px-6 py-2 rounded-full"
          >
            Get in Touch
          </a>
        </div>
      )}
    </nav>
  );
}
